export { quiz } from '../en-us/quiz';
